import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { BASE_URL } from '../Utils/base_url';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import { ContactRequest } from '../Api/Abonner';
import { toast } from 'react-toastify';
import '../Css/contact.css';

const Contact = () => {
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [sujet, setSujet] = useState('');
  const [contenu, setContenu] = useState();
  const [loading, setLoading] = useState(false);

  let location = useLocation();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const data = { nom: nom, email: email, sujet: sujet, contenu: contenu };
    ContactRequest(data).then(function (response) {
      console.log(response);
      if (response.data.title === "success") {
        toast.success(response.data.message);
      }
    }).catch(function (error) {
      console.log(error);
      if (error) {
        toast.error(error.response.data?.message);
      }

    }).finally(function () {
      setLoading(false);
      setNom('');
      setEmail('');
      setSujet('');
      setContenu('');
    });
  }
  return (
    <div>
      <Helmet>
        <title>Contact</title>
        <meta name='description' content='Contact.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <section className='contact'>
        <div className='contact_image_header'>
          <div className='img'>
            <img src={BASE_URL + localStorage.getItem('urlHero')} alt="header contact" />
          </div>
          <div className='content_header'>
            <div className='container'>
              <div className=''>
                <h1>Remplissez le formulaire</h1>
              </div>
            </div>
          </div>
        </div>
        <div className='container'>
          <form onSubmit={handleSubmit}>
            <div>
              <input type='text' className='form-control' required value={nom} onChange={(e) => setNom(e.target.value)} placeholder='Nom ...' />
              <input type='email' className='form-control ms-4' required value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Adresse email ...' />
            </div>
            <input type='text' className='form-control' value={sujet} required onChange={(e) => setSujet(e.target.value)} placeholder='Sujet ...' />
            <textarea className='form-control' value={contenu} required onChange={(e) => setContenu(e.target.value)} placeholder='Contenu ...' cols='30' rows='8'></textarea>
            {loading ? <Button className='btn btn_confirmContact' disabled>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                variant="info"
                className="spiner"
              />
              Chargement...
            </Button> : <button type='submit' className='btn btn_send_contact'>Envoyer la demande</button>}

          </form>
          <p className="version">Version 1</p>
        </div>
      </section>

    </div>
  )
}

export default Contact